'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * The image mask
 * @private
 * @type {StyledComponent}
 * @param {Object} props
 *   The properties
 * @param {(Array|String)} props.mixin
 *  An additional mixin
 * @param {(Array|String)} props.imageData
 *  background-image and default sizes as a mixin
 */
var Mask = _styledComponents2.default.div.withConfig({
  displayName: 'mask__Mask'
})(['', ';', ';width:var(--width,var(--original-width,0));height:var(--height,var(--original-height,0));background-size:var(--background-size,cover);background-position:var(--background-position,center center);'], function (props) {
  return props.mixin || '';
}, function (props) {
  return props.imageData || '';
});

/**
 * @private
 * @return {{imageData: ?(String|Array), mixin: ?(String|Array), children: (ReactElement|ReactElement[])}}
 *   Allowed propTypes for `<Mask/>`
 */
Mask.propTypes = {
  imageData: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.string]),
  mixin: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.string]),
  className: _propTypes2.default.string,
  children: _propTypes2.default.element
};

exports.default = Mask;